function galleryReset(){
  //Loop length, counter to inc and dec on left and right click, distance to move thumbs
  var $loopLength = 0;
  $('.product_gallery_nav .gallery-cell').each(function(){
    if($(this).css("display") != "none"){
    	$loopLength++
    }
  });
  var $counter = 0;
  var $block = $('.product_gallery_nav .gallery-cell').height();
  var $limit = $loopLength - 6;
  var $thumbHeight = $('.product_gallery_nav');
  

  $('.testing').animate({top: "0px"});

  setTimeout(function(){
    var $containerHeight = $('.product_gallery .gallery-cell').height();
  	$thumbHeight.height($containerHeight);
  }, 2000);
  

  if ($counter == $limit) {
    $('.righty').hide();
    $('.lefty').show();
  }

  if ($counter == 0) {
    $('.righty').show();
    $('.lefty').hide();
  }  
  //If thumbnails are more than four, slider is active
  if ($loopLength > 6 ) { 
    $('.righty').show();

    //Click left button, shift thumbs over
    $( ".righty" ).off().on( "click", function() {
      $counter++;
      $('.testing').animate({top: "-=" + $block+ "px"});
      $('.righty').show();
      $('.lefty').show();

      //This limits how many clicks are allowed, depending on thumbnail number
      if ($counter == $limit) {
        $('.righty').hide();
        $('.lefty').show();
      }
    });

    //Click right button, shift thumbs over
    $( ".lefty" ).off().on( "click", function() {
      $counter--;
      $('.testing').animate({top: "+=" + $block + "px"});
      $('.righty').show();
      $('.lefty').show();
      //When counter back to 0, right button is hidden again
      if ($counter == 0) {
        $('.righty').show();
        $('.lefty').hide();
      }  
    });

  }
  else{
  	$('.righty').hide();
    $('.lefty').hide();
  }
}

// A $( document ).ready() block.
$( document ).ready(function() {


	galleryReset();

  $(window).resize(function(){
    var $thumbHeight = $('.product_gallery_nav');
    var $containerHeight = $('.image__container ').height();

    $thumbHeight.height($containerHeight);
  })  

});